<template>
  <div class="translated-field">
    <div v-for="(locale, index) of locales" :key="locale" class="d-flex flex-row">
      <img :src="require(`@/assets/img/flags/${locale}.svg`)" :alt="$t(locale)" class="locale-flag flex-grow-0" />
      <input-field
        :ref="locale"
        :value="innerValue[locale]"
        :label="index === 0 ? label : null"
        :readonly="readonly"
        :disabled="disabled"
        class="flex-grow-1"
        @input="onInput(locale, $event)"
        @blur="onBlur"
      />
    </div>
  </div>
</template>

<script>
import InputField from '@/components/form/inputField.vue';

import getRef from '@/utils/getRef';

export default {
  name: 'TranslatedField',

  components: { InputField },

  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    const locales = this.$i18n.locales();
    return {
      innerValue: {},
      defaultLocale: locales[0],
      locales: [...locales],
    };
  },

  methods: {
    onInput(locale, value) {
      this.innerValue[locale] = value;
      this.$emit('input', this.innerValue);
    },

    onBlur() {
      this.$emit('blur', this.innerValue);
    },

    focus() {
      const ref = getRef(this.$refs, this.defaultLocale);
      if (ref) {
        ref.focus();
      }
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(next) {
        const value = next || {};
        this.innerValue = {};
        this.locales.forEach((locale) => {
          this.innerValue[locale] = value[locale] || null;
        });
      },
    },
  },
};
</script>

<style scoped>
.locale-flag {
  width: 2rem;
}

.translated-field >>> .boon-input {
  border-bottom-color: #ccc;
}

.translated-field >>> .boon-input:focus ~ .focus-border,
.translated-field >>> .boon-input-filled ~ .focus-border {
  background-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/form/TranslatedField.vue